import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { PARENT_HEADER_STEPS } from 'pages/digitalRetailing/DigitalRetailingConstant';
import { useTranslation } from 'react-i18next';

interface ParentHeaderProps {
  onCloseModal: () => void;
  currentStep?: number;
}

const ParentHeader: React.FC<ParentHeaderProps> = ({ onCloseModal, currentStep = 0 }) => {
  const { t } = useTranslation();
  return (
    <div className='dr-header'>
      <ul className='wizard-step list-unstyled mb-0 hide-scrollbar'>
        {PARENT_HEADER_STEPS(t)?.map(({ step, name, stepAllowed }) => {
          return (
            <li key={step} className={stepAllowed.includes(currentStep) ? 'current' : ''}>
              {name}
            </li>
          );
        })}
      </ul>
      <button type='button' className='btn-close' onClick={onCloseModal}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default ParentHeader;
